import React from "react";
import { Typography, Grid, Section, Divider } from "../../core";
import styled from "styled-components";
import { MixStyle, media, theme } from "../../styles";

import AddSizerForm from "../../components/AddSizerForm";

const { colors } = theme;
const Container = styled.div`
  margin: 50px 0px;
`;
const TittleWraper = styled.div`
  ${MixStyle.flexCenter};
  h1 {
    ${media.minitablet`font-size:36px;`};
  }
  .d-inline--block {
    display: inline-block;
  }
`;

const AddSizer = () => {
  return (
    <Container>
      <Grid>
        <Section padding="10px 50px">
          <TittleWraper>
            <Typography
              className="d-inline--block"
              align="center"
              as="h1"
              color={colors.darkPink}
              weight="bold"
            >
              Add Sizer
              <Divider />
            </Typography>
          </TittleWraper>
          <AddSizerForm />
        </Section>
      </Grid>
    </Container>
  );
};

export default AddSizer;
